<template>
  <a-drawer :title="title" placement="right" :closable="false" :forceRender="true" :visible="visibles"
    :destroyOnClose="true" :bodyStyle="{ padding: '10px' }" :width="drawerWidth" @close="onClose">
    <a-spin :spinning="copyLoading">
      <div class="container">
        <a-form :form="form" layout="inline">
          <div class="item">
            <a-form-item label="产品名称" layout="inline">
              <a-input
                v-decorator="['productName', { rules: [{ required: true, whitespace: true, message: '产品名称不能为空' }], initialValue: detail.productName }]"
                style="width:250px" placeholder="输入产品名称" />
            </a-form-item>
          </div>
          <a-tabs style="height:calc(100vh - 160px);">
            <a-tab-pane key="0" tab="原料">
              <a-row justify="space-between" type="flex" style="margin-bottom:10px">
                <a-space>
                  <a-button type="primary" @click="toggleAddVisible">添加</a-button>
                  <a-button type="danger" @click="delectItem" :disabled="!selectedRowKeys.length > 0"
                    ghost>删除</a-button>
                </a-space>
                <a-form-item label="产品盘重" layout="inline">
                  {{ detail.totalWeight }}KG
                  <!-- <a-input style="width:250px" placeholder="设置产品盘重" /> -->
                </a-form-item>
              </a-row>
              <a-table :scroll="{ x: 0, y: 'calc(100vh - 300px)' }" :columns="rawColumns" :pagination="false"
                :loading="rawLoading" :row-key="record => record.rawId"
                :row-selection="{ selectedRowKeys, onChange: onSelectChange, getCheckboxProps: checkboxProps }"
                :dataSource="raw.formulaRawProductVOList">
                <span slot="uasge" slot-scope="text">
                  {{ text == null || text == '' ? text : text.toFixed(3) }}
                </span>
                <template slot-scope="text, record, index" slot="percentage">
                  <span v-if="index + 1 == raw.formulaRawProductVOList.length">
                    {{ text == null || text == '' ? text : text.toFixed(3) }}
                  </span>
                  <cell-editor v-else :len="3" :max="100" :min="0" :background="true" :item="record" name="percentage"
                    @blur="target => itemUpdate(target, 'percentage')" :text="text" />
                </template>
                <span slot="unit">KG</span>
              </a-table>
            </a-tab-pane>
            <a-tab-pane key="1" tab="营养分析">
              <a-table :pagination="false" :dataSource="nut" :row-key="record => record.id"
                :scroll="{ x: 0, y: 'calc(100vh - 260px)' }" :columns="nutColumns">
                <template slot="content" slot-scope="text, record">
                  {{ text != null ? text.toFixed(record.unit === '' || record.unit === 'Kcal' ? 0 : 2) : text }}
                </template>
              </a-table>
            </a-tab-pane>
          </a-tabs>
          <a-row class="footer" justify="space-between" align="middle" type="flex">
            <a-button @click="onClose">关闭</a-button>
            <a-button type="primary" @click="ok">确定</a-button>
          </a-row>
        </a-form>
      </div>
    </a-spin>
    <raw-model :hidden="addVisible" @ok="insertRaw" @cancel="toggleAddVisible({})" />
  </a-drawer>
</template>

<script>
import CellEditor from '../../Nhf/Compound/editor/CellEditor0.vue'
import RawModel from '../../Nhf/Compound/modal/RawModel.vue'
import { productMixins } from '../unitls'

export default {
  components: { RawModel, CellEditor },
  props: ['hidden'],
  mixins: [productMixins],
  computed: {
    prductName() {
      return this.detail.productName
    },
    visibles() {
      return this.hidden ? true : false
    },
    title() {
      return `复制产品${this.detail.productName}`
    }
  },

  data() {
    return {
      drawerWidth: 1200,
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      form: this.$form.createForm(this),
      productName: '',
      copyLoading: false,
      addVisible: false,
      rawLoading: false,
      detail: { productName: '' },
      raw: {},
      nut: [],
      rawColumns: [
        {
          dataIndex: 'rawName',
          title: '原料名称',
          width: 380,
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false
            }
            return a.rawName.localeCompare(b.rawName, 'zh')
          },
          sortDirections: ['descend', 'ascend'],
          customRender: (text, row, index) => {
            let str = this.overseasFlag == '1' ? (row.aliasName || text) : text
            if (index < this.raw.formulaRawProductVOList.length - 1) {
              return <span>{str}</span>
            }
            return {
              children: <span>{str}</span>,
              attrs: {
                colSpan: 2
              }
            }
          }
        },
        {
          dataIndex: 'rawCode',
          title: '原料代码',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false
            }
            return a.rawCode - b.rawCode
          },
          sortDirections: ['descend', 'ascend'],
          align: 'center',
          customRender: this.renderContent
        },
        {
          dataIndex: 'percentage',
          title: '用量%',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false
            }
            return a.percentage - b.percentage
          },
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'percentage' },
          align: 'center'
        },
        {
          dataIndex: 'uasge',
          title: '用量(批次量)',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false
            }
            return a.uasge - b.uasge
          },
          scopedSlots: { customRender: 'uasge' },
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          dataIndex: 'unit',
          title:'单位',
          scopedSlots: { customRender: 'unit' },
          align:'center',
          width:50
        }
      ],
      nutColumns: [
        {
          dataIndex: 'name',
          title: '指标名称'
        },
        {
          dataIndex: 'fullName',
          title: '指标全称'
        },
        {
          dataIndex: 'content',
          title: '数值',
          sorter: (a, b) => {
            if (a.rawName == '合计') {
              return false
            }
            return a.content - b.content
          },
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'content' },
          align: 'center'
        },
        {
          dataIndex: 'unit',
          title: '单位',
          width: 90
        }
      ]
    }
  },
  watch: {
    hidden(id) {
      if (id) {
        this.getDetail({productId: this.rowId})
        this.rawList({productId: this.rowId})
        this.nutList({productId: this.rowId})
      } else {
        this.raw = {}
        this.nut = {}
      }
    },
    raw(val) {
      if (val) {
        this.getTotal(val.formulaRawProductVOList)
      }
    }
  },
  mounted() {
    const viewportWidth = window.innerWidth;
    const _width = viewportWidth * 0.8;
    if (_width < 1200) {
      this.drawerWidth = _width;
    }
  },
  methods: {
    checkboxProps(record) {
      return {
        props: {
          disabled: record.rawName === '合计',
          name: record.rawName
        }
      }
    },
    renderContent(value, row, index) {
      const obj = {
        children: value,
        attrs: {}
      }
      if (index === this.raw.formulaRawProductVOList.length - 1) {
        obj.attrs.colSpan = 0
      }
      return obj
    },

    delectItem() {
      let list = [...this.raw.formulaRawProductVOList]
      this.selectedRowKeys.forEach(rawId => {
        list.splice(
          list.findIndex(item => item.rawId === rawId),
          1
        )
      })
      this.cleanSelect()
      this.raw.formulaRawProductVOList = list
      this.getTotal()
    },

    itemUpdate(item, column) {
      let newData = [...this.raw.formulaRawProductVOList]
      let target = newData.filter(i => i.rawId === item.rawId)[0]
      if (target) {
        let value = item[column] ? item[column] : 0
        target[column] = value
        const uasge = value.div(100).mul(this.detail.totalWeight)
        Object.assign(target, item, { uasge })
        this.raw.formulaRawProductVOList = newData
        this.getTotal()
      }
    },

    insertRaw(val) {
      const status = this.checkAddRaw(val)
      if (status) {
        const addList = val.map(i => {
          const { name, code } = i
          return { ...i, uasge: null, percentage: null, rawName: name, rawCode: code }
        })
        this.raw.formulaRawProductVOList = [...addList, ...this.raw.formulaRawProductVOList]
        this.toggleAddVisible()
        this.$nextTick(() => {
          this.getTotal()
        })
      } else {
        this.$message.warn('不能添加重复原料')
      }
    },

    getTotal(arg) {
      this.$nextTick(() => {
        let all = arg || [...this.raw.formulaRawProductVOList].filter((item, index) => index < this.raw.formulaRawProductVOList.length - 1)
        this.allRaw = all
        const allList = [
          ...all,
          {
            rawName: '合计',
            rawId: 23000,
            percentage: all.reduce((val, item) => val + (item.percentage === null || item.percentage === '' ? 0 : item.percentage > 0.001 ? Number(item.percentage.toFixed(3)) : item.percentage), 0),
            uasge: all.reduce((val, item) => val + (item.uasge === null || item.uasge === '' ? 0 : item.uasge > 0.001 ? Number(item.uasge.toFixed(3)) :item.uasge), 0)
          }
        ]
        this.raw.formulaRawProductVOList = allList
      })
    },
    checkAddRaw(list) {
      let flag = true
      this.raw.formulaRawProductVOList.map(i => {
        const arr = list.filter(item => i.rawId === item.rawId)
        if (arr.length) flag = false
      })
      return flag
    },
    toggleAddVisible() {
      this.addVisible = !this.addVisible
    },
    async ok() {
      let valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.detail.productName = valid.productName
      if (this.raw.formulaRawProductVOList.length) {
        let item = this.raw.formulaRawProductVOList[this.raw.formulaRawProductVOList.length - 1]
        if (item.percentage.toFixed('3') != "100.000") {
          this.$message.warn('当前配方原料用量合计不为100%')
          return false
        }
      }
      await this.copyItem()
      this.$emit('ok')
    },
    async getDetail(data) {
      await this.fetchGet({
        name: 'detail',
        data,
        actions: this.formulaproductDetail,
        loading: 'detailLoading'
      })
    },
    onClose() {
      this.$emit('cancel')
    },
    async copyItem() {
      const formulaRawProductDTOList = this.allRaw.map(i => {
        const { rawId, percentage } = i
        return { rawId, percentage }
      })
      const { productName, totalWeight, id: productId } = this.detail
      await this.fetchPost({
        actions: this.copyFormulaProduct,
        loading: 'copyLoading',
        data: {
          formulaRawProductDTOList,
          productName,
          totalWeight,
          productId
        }
      })
    },
    async rawList({ id, ...arg }) {
      await this.fetchGet({
        name: 'raw',
        actions: this.selectFormulaProductRawByProductId2,
        loading: 'rawLoading',
        data: {
          productId: id,
          size: 1000,
          ...arg
        }
      })
    },
    async nutList({ id, ...arg }) {
      this.fetchGet({
        actions: this.selectFormulaProductNutritionByProductId,
        name: 'nut',
        data: {
          productId: id,
          size: 1000,
          ...arg
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.footer {
  height: 50px;
  margin: 0 -10px;
  padding: 0 10px;
  border-top: 1px solid #e8e8e8;
}
</style>
